export default __webpack_public_path__ + "static/media/room-3Bed-tripple_compressed.ecf6dbb3.mp4";